import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapTenantAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] =>
  mapStaticMutation(previousState.onboarding, currentState.onboarding, {
    successEventName: "tenant_setup_completed",
    errorEventName: "tenant_setup_failed"
  });
